import { useAppRouteParams } from "@/AppRoutes";
import { getAdminFrontendAddon } from "@/api/admin/frontendAddons";
import { usePageTitleEffect } from "@/components/AppProvider/AppOrgsAndInvitedOrgsProvider";
import { FrontendAddonEditableNotify } from "@/components/FrontendAddonForm/FrontendAddonFormEdit/components/FrontendAddonEditableNotify";
import { FrontendAddonVersionUpdate } from "@/components/FrontendAddonForm/FrontendAddonFormEdit/components/FrontendAddonVersionUpdate";
import { FrontendAddonHeader } from "@/components/FrontendAddonHeader";
import { LoadingCover } from "@/components/LoadingCover";
import { FrontendAddonWithTargetVersionRaw } from "@/domain/FrontendAddon";
import React, { useEffect, useState } from "react";
import { AppTopNavSlot } from "../../components/AppTopNav";
import { ErrorWrapper } from "../../components/ErrorWrapper";
import parentStyles from "../index.module.css";

export const PageAdminFrontendMastersVersionUpdate: React.FC = () => {
  const { frontendAddonId } = useAppRouteParams();
  const [, throwReactError] = useState<never>();
  usePageTitleEffect("フロントエンドアドオンマスタバージョン更新");

  const [targetFrontendAddon, setTargetFrontendAddon] = useState<
    FrontendAddonWithTargetVersionRaw | undefined
  >(undefined);
  useEffect(() => {
    const fetchFrontendAddon = async () => {
      try {
        const addon = await getAdminFrontendAddon({ frontendAddonId });
        setTargetFrontendAddon(addon);
      } catch (e) {
        throwReactError(() => {
          throw e;
        });
      }
    };
    fetchFrontendAddon();
  }, [frontendAddonId]);

  const editPath = `/admin/frontendmasters/${frontendAddonId}/frontend_addon_edit?tab=version`;

  return (
    <div className={parentStyles.root}>
      <div>
        <AppTopNavSlot>
          <FrontendAddonHeader
            parentTitle="フロントエンドアドオンマスタ"
            addonName={targetFrontendAddon?.name}
            addonPath={editPath}
            listPath="/admin/frontendmasters"
          />
        </AppTopNavSlot>
      </div>
      <FrontendAddonEditableNotify targetFrontendAddon={targetFrontendAddon} />
      <div className={parentStyles.pageContent}>
        <ErrorWrapper>
          {targetFrontendAddon ? (
            <FrontendAddonVersionUpdate
              isProd={process.env.APP_ENV === "production"}
              returnPath={editPath}
              targetFrontendAddon={targetFrontendAddon}
            />
          ) : (
            <LoadingCover />
          )}
        </ErrorWrapper>
      </div>
    </div>
  );
};
